function OrdersTable({
  orders,
  selectOrder,
  entregarOrder,
  selectedDay,
  selectedHour,
}) {
  return (
    <table className="orders-table">
      <thead>
        <tr style={{ textAlign: "center" }}>
          <th style={{ width: "9%" }}>Orden</th>
          <th style={{ width: "28%" }}>Cliente</th>
          <th style={{ width: "28%" }}>Productos</th>
          <th style={{ width: "9%" }}>Total</th>
          <th style={{ width: "22%" }}>Acción</th>
        </tr>
      </thead>

      <tbody>
        {orders?.map((order) => (
          <tr key={order.folio} style={{ textAlign: "center" }}>
            <td>{order.folio}</td>
            <td>{order.user_name}</td>
            <td style={{ textAlign: "left" }}>
              {order.detalle
                .filter((ite) => {
                  if (
                    ite.selectedDate === selectedDay &&
                    (ite.selectedTime === selectedHour ||
                      selectedHour === "cantidad")
                  ) {
                    return true;
                  }
                  let fech = new Date(order.fecha.seconds * 1000);
                  let dateord = fech.toISOString().split("T")[0];
                  let hora = fech.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false, // Set to true for AM/PM
                  });
                  if (
                    !ite.selectedDate &&
                    dateord === selectedDay &&
                    (hora === selectedHour || selectedHour === "cantidad")
                  ) {
                    return true;
                  }
                  return false;
                })
                .slice(0, 4)
                .map((element, index) => {
                  return (
                    <>
                      {index === 3 ? (
                        <strong>{"...mas"}</strong>
                      ) : (
                        <strong>
                          {"-" +
                            element.name +
                            "(" +
                            element.cantidad +
                            ")" +
                            "\n "}
                        </strong>
                      )}
                      <br />
                    </>
                  );
                })}
            </td>
            <td style={{ justifyContent: "center" }}>
              {order.detalle
                .filter((ite) => {
                  if (
                    ite.selectedDate === selectedDay &&
                    (ite.selectedTime === selectedHour ||
                      selectedHour === "cantidad")
                  ) {
                    return true;
                  }
                  let fech = new Date(order.fecha.seconds * 1000);
                  let dateord = fech.toISOString().split("T")[0];
                  let hora = fech.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false, // Set to true for AM/PM
                  });
                  if (
                    !ite.selectedDate &&
                    dateord === selectedDay &&
                    (hora === selectedHour || selectedHour === "cantidad")
                  ) {
                    return true;
                  }
                  return false;
                })
                .reduce((acc, item) => {
                  return item.cantidad + acc;
                }, 0)}
            </td>
            <td>
              <button
                className="detail-btn"
                onClick={(e) => {
                  e.preventDefault();
                  selectOrder(order);
                }}
              >
                Detalles
              </button>
              {/* <br /> */}
              <button
                className="ready-btn"
                onClick={(e) => {
                  e.preventDefault();
                  entregarOrder(order);
                }}
              >
                Listo
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default OrdersTable;
